if ($('.id-682').length) {
    $('#content .content-inner').append($('.sectionDescription .wrapper'));
    $('.news-item').each(function () {

        var $title = $(this).find('a.title');

        var text = $title.text();
        if (text.includes(translation('kontakty')+' – ')) {
            $title.text(
                text.replace(translation('kontakty')+' – ', '')
            );
        }
        

        var link = $title.attr('href');
        if (link) {
            $(this).css('cursor', 'pointer');
            $(this).on('click', function (e) {
                if (!$(e.target).is('a')) {
                    window.location.href = link;
                }
            });
        }

        if (!$title.length) return;
     
        if (!link) return;

        const mapping = NEWS_BUTTON_MAP.find(m =>
            link.includes(m.match)
        );
        if (!mapping) return;

        if ($(this).find('.newsItemButton').length) return;

        const $button = $(`
            <a href="${mapping.match}"
               class="newsItemButton btn btn-primary">
                ${mapping.label}
            </a>
        `);

        $(this).append($button);



    });



}